import { EN, KK, RU, UZ } from '../constants/Language';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import 'moment/locale/uz-latn';
import 'moment/locale/kk';
export function getMomentLocale(languageId) {
    switch (languageId) {
        case RU:
            return 'ru';
        case UZ:
            return 'uz-latn';
        case KK:
            return 'kk';
        case EN:
        default:
            return 'en-gb';
    }
}



// WEBPACK FOOTER //
// ./src/shared/momentLocale.js